var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92139 10.0432V8.05074C6.92139 4.75316 7.91764 2.07324 12.8989 2.07324C17.8801 2.07324 18.8764 4.75316 18.8764 8.05074V10.0432",
    stroke: "#000",
    strokeWidth: 1.49438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8983 18.5113C14.2739 18.5113 15.389 17.3962 15.389 16.0207C15.389 14.6451 14.2739 13.53 12.8983 13.53C11.5228 13.53 10.4077 14.6451 10.4077 16.0207C10.4077 17.3962 11.5228 18.5113 12.8983 18.5113Z",
    stroke: "#000",
    strokeWidth: 1.49438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8793 21.998H7.9168C3.9318 21.998 2.93555 21.0017 2.93555 17.0167V15.0242C2.93555 11.0392 3.9318 10.043 7.9168 10.043H17.8793C21.8643 10.043 22.8606 11.0392 22.8606 15.0242V17.0167C22.8606 21.0017 21.8643 21.998 17.8793 21.998Z",
    stroke: "#000",
    strokeWidth: 1.49438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3885c30adcfdae97bce60ccfe04a2ae8.svg";
export { ForwardRef as ReactComponent };